import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    langMap: [],
    profileImage: "",
    cropFamilies: [],
  },
};

export const updatePestSpecificInfoSlice = createSlice({
  name: "updatePestSpecificInfo",
  initialState,
  reducers: {
    updateAllData: (state, action) => {
      state.value = action.payload;
    },
    replaceIndex: (state, action) => {
      const { index, data } = action.payload;
      if (state.value.langMap[index]) {
        state.value.langMap[index] = data;
      }
    },
    addNewLangData: (state, action) => {
      const existingIndex = state.value.langMap.findIndex(
        (item) => item.langCode === action.payload.langCode
      );
      if (existingIndex !== -1) {
        state.value.langMap[existingIndex] = action.payload;
      } else {
        state.value.langMap.push(action.payload);
      }
    },
    updateProfileImage: (state, action) => {
      state.value.profileImage = action.payload;
    },
    updateCropFamilies: (state, action) => {
      state.value.cropFamilies = action.payload;
    },
    resetState: (state) => {
      state.value = initialState.value;
    },
  },
});

export const {
  updateAllData,
  replaceIndex,
  addNewLangData,
  updateProfileImage,
  updateCropFamilies,
  resetState,
} = updatePestSpecificInfoSlice.actions;

export default updatePestSpecificInfoSlice.reducer;
